import React, {Component} from 'react'
import {Link} from "react-router";
import './ProgressSection.scss'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import {Circle} from 'rc-progress';
import {Userpilot} from 'userpilot';

const triggerUserpilot = token => token && Userpilot.trigger(token)

export default class ProgressSection extends Component {

    renderProgressLink = item => {
        const {setActiveTab} = this.props

        if (!item.link) return item.name

        const isTabLink = setActiveTab && Number.isInteger(+item.link)
        const handleClick = () => {
            isTabLink && setActiveTab(+item.link)
            triggerUserpilot(item.user_pilot_token)
        }

        return isTabLink ?
            <span className='link' onClick={handleClick}>{item.name}</span> :
            <Link to={item.link} onClick={handleClick}>{item.name}</Link>
    }

    render() {
        const {title, data, percent} = this.props
        return (
            <div className='progress-section'>

                <div className='left-side'>
                    <div className='title'>{title}</div>
                    <div className='progress-container'>
                        <Circle percent={percent} strokeWidth="20" trailWidth="20" strokeColor="green"
                                strokeLinecap='butt'/>
                        <div className='percent'> {percent}%</div>
                    </div>
                </div>
                <div className='right-side'>
                    <div className='header'>
                        <div className='title'>Category</div>
                        <div className='status'> Status</div>
                    </div>
                    <ul className='progress-list'>
                        {data.map(item => (
                            <li key={item.name} className='progress-list-item'>
                                {this.renderProgressLink(item)}
                                <div className='dotted-line'></div>
                                <div className='item-status'>
                                    <FontAwesomeIcon size='lg' color={item.done ? '#378805' : '#d3d3d3'}
                                                     icon={faCheckCircle}/> {item.done && 'Complete'}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        )
    }
}